import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';
import { translationHelper } from '~/helpers/translation.helper';
declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_bettingslip_system_modal',
    templateUrl: './bettingslip_system_modal.html',
})
export class BettingSlipSystemModal implements OnInit {
    // public isClicked = [];
    @Output('systemSlip_ChangeAmount') public systemSlipChangeAmount = new EventEmitter();
    public init: boolean;
    constructor(public tournamentsService: TournamentsService, private _translate: translationHelper) {}
    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
    }
    public factorial(e) {
        if (e == 1 || e == 0) {
            return 1;
        } else {
            return e * this.factorial(e - 1);
        }
    }
    public combination(r) {
        const n = this.tournamentsService.systemSlips.length;
        return this.factorial(n) / (this.factorial(n - r) * this.factorial(r));
    }

    public SystemSlip_ChangeAmount(e) {
        this.systemSlipChangeAmount.next(e);
    }
    public BettingSlip_System_Button_Click(i, x, y) {
        if (this.tournamentsService.isClicked[i] == true) {
            const systemslip = 'systemspanid+' + i;
            this.tournamentsService.SystemModalButtonValueArray.splice(i, 1);
            this.tournamentsService.isClicked[i] = false;
        } else {
            const systemslip = 'systemspanid+' + i;
            this.tournamentsService.SystemModalButtonValueArray[i] = document.getElementById(systemslip).innerHTML;
            this.tournamentsService.isClicked[i] = true;
        }

        // console.log("ARRRAYY", this.tournamentsService.SystemModalButtonValueArray);
    }
    public BettingSlip_System_Button_Ok() {
        // $('#BettingSlip_System_Modal').modal('is active');
        if (this.tournamentsService.SystemModalButtonValueArray.length != 0) {
            this.tournamentsService.SystemModalButtonValue = this._translate.getT('System') + ' ';
            for (let i = 0; i < this.tournamentsService.SystemModalButtonValueArray.length; i++) {
                if (this.tournamentsService.SystemModalButtonValueArray[i] != null) {
                    if (i == this.tournamentsService.SystemModalButtonValueArray.length - 1) {
                        this.tournamentsService.SystemModalButtonValue += this.tournamentsService.SystemModalButtonValueArray[
                            i
                        ];
                    } else {
                        this.tournamentsService.SystemModalButtonValue +=
                            this.tournamentsService.SystemModalButtonValueArray[i] + ',';
                    }
                }
            }
        } else {
            this.tournamentsService.SystemModalButtonValue = this._translate.getT('System_Combinations');
        }
        $('#BettingSlip_System_Modal').modal('hide');

        // $('#BettingSlip_System_Modal').remove();
        // this.tournamentsService.obj_bettingslip_system_modal = undefined;

        this.systemSlipChangeAmount.next(null);
        // this.isClicked = [];
    }

    ngOnDestroy(): void {}
}
